<script>
import { Form, Field, Toast, Dialog } from 'vant'
import ImageUploader from '@/components/org/ImageUploader'
import AreaSelector from '@/components/org/AreaSelector'
import PickerSelector from '@/components/org/PickerSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import MatchBrand from '@/tbs/model/vo/MatchBrand'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-organization-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-form': Form,
        'van-field': Field,
        'image-uploader': ImageUploader,
        'area-selector': AreaSelector,
        'picker-selector': PickerSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchBrand: {
                id: null,
                organizationId: null,
                name: null,
                logoUrl: null,
                logo: null,
                areaId: null,
                area: null,
                crowd: null,
            },
            cityRegion: {
                areaList: null,
                areaIdList: null
            },
            isEdit: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        crowdIndex() {
            if (this.matchBrand.crowd) {
                const crowdOptions = (new MatchBrand).crowdOptions
                for (let i = 0; i < crowdOptions.length; i++) {
                    let item = crowdOptions[i]
                    if (item.value == this.matchBrand.crowd) {
                        return i
                    }
                }
            }
            return 0
        },
        crowdOptions() {
            return (new MatchBrand).crowdOptions
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.matchBrand.name) {
                    Toast(this.locale['match-brand-name-required'])
                }
                else if (!(this.matchBrand.logo || this.matchBrand.logoUrl)) {
                    Toast(this.locale['match-brand-logo-required'])
                }
                else if (!this.matchBrand.area) {
                    Toast(this.locale['match-brand-area-required'])
                }
                else if (!this.matchBrand.crowd) {
                    Toast(this.locale['match-brand-crowd-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-match-brand'],
                message: this.locale['delete-match-brand-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete'
                })
            }).catch(() => {
                // on cancel
            })
        },
        onAreaSelectorDataChange(data) {
            console.log('onAreaSelectorDataChange', this.isEdit, data)
            this.matchBrand.areaId = this.convertAreaCode2Id(data.code)           
            console.log('matchBrand.areaId', this.matchBrand.areaId, data.code)
            this.matchBrand.area = data.label
        },
        onLogoUploaderDataChange(data) {
            console.log('onLogoUploaderDataChange', this.isEdit, data)
            this.matchBrand.logoUrl = null
            this.matchBrand.logo = data
            this.forceUpdateBindableData()
        },
        onCrowdDataChange(data) {
            this.matchBrand.crowd = data.value
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.matchBrand.name 
                && (this.matchBrand.logo || this.matchBrand.logoUrl)
                && this.matchBrand.area 
                && this.matchBrand.crowd) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            if (this.validateSubmitRequired()) {
                this.$emit('custom-event', {
                    type: 'save',
                    data: {
                        id: this.matchBrand.id,
                        organizationId: this.matchBrand.organizationId,
                        name: this.matchBrand.name,
                        logo: this.matchBrand.logo,
                        area: this.matchBrand.area,
                        areaId: this.matchBrand.areaId,
                        areaIdList: this.cityRegion.areaIdList,
                        crowd: this.matchBrand.crowd,    
                        sportType: this.locale['sport-type-1']
                    }
                })
            }
        },
        convertAreaCode2Id(code) {
            console.log('convertAreaCode2Id', code)
            if (this.cityRegion && this.cityRegion.areaIdList) {
                const areaIdList = this.cityRegion.areaIdList
                if (areaIdList.province_list[code]) {
                    return areaIdList.province_list[code]
                }
                else if (areaIdList.city_list[code]) {
                    return areaIdList.city_list[code]
                }
                else if (areaIdList.county_list[code]) {
                    return areaIdList.county_list[code]
                }
            }
            return '1'
        },
        convertAreaId2Code(id) {
            if (this.cityRegion && this.cityRegion.areaIdList) {
                const areaIdList = this.cityRegion.areaIdList
                for (let p in areaIdList.province_list) {
                    if (areaIdList.province_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.city_list) {
                    if (areaIdList.city_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.county_list) {
                    if (areaIdList.county_list[p] == id) {
                        return p
                    }
                }
            }
        },
        forceUpdateBindableData() {
            const name = this.matchBrand.name
            this.matchBrand.name = ' ' + name
            this.matchBrand.name = name
        }
    },
}
</script>

<template>
    <div class="match-brand-edit">
        <van-form>
            <van-field 
                name="match-brand-name" 
                v-model="matchBrand.name" 
                :label="locale['match-brand-name-label']" :placeholder="locale['match-brand-name-placeholder']"
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="50" 
            />
            <image-uploader
                :label="locale['match-brand-logo-label']"
                :description="locale['match-brand-logo-placeholder']"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.matchBrand.logoUrl, 400, 400)"
                @change-data="onLogoUploaderDataChange"
            />
            <area-selector
                :label="locale['city-region']"
                :all="locale['all']"
                :allArea="locale['whole-nation']"
                :areaList="cityRegion.areaList"
                :selectedAreaCode="convertAreaId2Code(matchBrand.areaId)"
                :selectedAreaLabel="matchBrand.area"
                @change-data="onAreaSelectorDataChange"
            />
            <van-cell
                class="van-cell-field"
                :title="locale['sport-type']"
                :value="locale['sport-type-1']"
            />
            <picker-selector
                :label="locale['match-brand-crowd-label']"
                :options="crowdOptions"
                :value="matchBrand.crowd"
                :index="crowdIndex"
                @change-data="onCrowdDataChange"
            />
        </van-form>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>